export const CategoryConstants = {
  LEVEL_TYPE: {
    MAIN_GROUP: 'MAINGROUP',
    TOOL: 'TOOL',
    SUBGROUP: 'SUBGROUP',
  },

};
